import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Spinner,
  Input
} from "reactstrap";
import { consignmentService } from "../../../../../services/consignment.services";

const todayString = () => new Date().toISOString().slice(0, 10);

// "Ordered": office records the date of order and the PO number
const OrderedModal = (props) => {
  const [loading, setLoading] = useState(false);
  const [orderDate, setOrderDate] = useState(todayString());
  const [poNumber, setPoNumber] = useState("");
  const [error, setError] = useState({});

  const modalClose = (flag) => {
    props.toggle(flag);
    setOrderDate(todayString());
    setPoNumber("");
    setError({});
  };

  const handleOrdered = async () => {
    setLoading(true);
    try {
      await consignmentService.orderedConsignment({
        id: props.bookingId,
        order_date: orderDate,
        po_number: poNumber,
      });
      modalClose(true);
      props.onReload();
    } catch (errors) {
      setError(errors && typeof errors === "object" ? errors : { common: [String(errors)] });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      size="md"
      backdrop="static"
      centered
      isOpen={props.isOpen}
      toggle={() => modalClose(false)}
    >
      <ModalHeader toggle={() => modalClose(false)}>
        Ordered
      </ModalHeader>
      <ModalBody>
        <div className="form-group">
          <label>
            Date of Order<span className="text-danger">*</span>
          </label>
          <Input
            type="date"
            value={orderDate}
            onChange={(e) => setOrderDate(e.target.value)}
          />
          {error.order_date && <span className="text-danger">{error.order_date}</span>}
        </div>
        <div className="form-group">
          <label>
            PO Number<span className="text-danger">*</span>
          </label>
          <Input
            type="text"
            placeholder="Enter PO number"
            value={poNumber}
            onChange={(e) => setPoNumber(e.target.value)}
          />
          {error.po_number && <span className="text-danger">{error.po_number}</span>}
        </div>
        {error.common && <span className="text-danger">{error.common}</span>}
      </ModalBody>
      <ModalFooter>
        <div className="">
          <button
            onClick={() => modalClose(false)}
            className="btn btn-secondary mr-2"
            data-dismiss="modal"
          >
            Cancel
          </button>
          {!loading && (
            <button className="btn btn-primary" onClick={handleOrdered}>
              Ok
            </button>
          )}
          {loading && (
            <button className="btn btn-primary loader-icon" disabled>
              <Spinner className="img-svg"></Spinner>
            </button>
          )}
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default OrderedModal;
